<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          <div>{{ $t("labels.BankStatements") }}</div>
        </v-card-title>
        <v-card-text>
          <p  v-html="$t('messages.BankStatementDesc')" />         
           <v-btn  @click="RequestStatement" color="primary">{{ $t("labels.Authorize") }}</v-btn> 
            <v-row>
              <v-col cols="12" v-if="app.Requests && app.Requests.length>0">
                <v-simple-table >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Applicant</th>
                        <th class="text-middle">{{ $t("labels.RequestStatus") }}</th>
                        <!-- <th>Request Date</th> -->
                        <th>{{ $t("labels.RequestDate") }}</th>                       
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in app.Requests" :key="item.RequestID">
                        <td>{{item.ApplicantName}}</td>
                        <td class="align-middle">
                        <span v-if="isNotRequested(item)">
                          {{ $t("labels.FlinksStatusNotRequested") }}
                        </span>
                        <span v-if="isRequested(item)" variant="warning">
                          {{ $t("labels.FlinksStatusRequestSent") }}
                        </span>
                        <span v-if="isRecieved(item)" variant="success">
                          {{ $t("labels.FlinksStatusReceivedV2") }}
                        </span>
                        </td>
                        <!-- <td class="align-middle">{{ item.strRequestDate }}</td> -->
                        <td class="align-middle">{{ item.strResponseDate }}</td>                       
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
             
            </v-row>                    
        </v-card-text>
        <v-card-actions class="mb-5 mt-10">
            <v-spacer />
            <v-btn @click="next" color="primary">{{ $t("labels.Next") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog ref="MergeDocumentsSelectModal" v-model="showRequestFlag" persistent   max-width="800px">  
      <v-card>
        <v-card-title>
          <span class="headline" v-text="$t('labels.RequestBankStatements')"></span>
        </v-card-title>   
         <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select  v-model="RequestApplicant" :items="LstApplicants" item-text="Label" item-value="Value">
                  <template slot="label">
                    <span v-html="$t('labels.MTG_Applicants')" />
                  </template>
                </v-select> 
              </v-col>
            </v-row>
          </v-container>
         </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="CloseRequestModal">{{$t('labels.Close')}}</v-btn>
          <v-btn :disabled="RequestApplicant == null" color="blue darken-1" text @click="RequestdialogSave(RequestApplicant)">{{$t('labels.SendRequest')}}</v-btn>
        </v-card-actions>
      </v-card>                   
    </v-dialog>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>   
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import domainHelper from "@/services/domainHelper";
export default {
  components: {
    drawer, 
  },
  data() {
    return {
      frm: {
          LoginID: null,
          Tag: null,
          Institution: null,
          AccountId:null
            },
      LstApplicants:[],
      showRequestFlag: false, 
      RequestApplicant: null,
      tabModel: "tab-1",    
      loadFlag: false,    
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      app: model.appModel(),
      lan: localStorageSvc.getLan()
    };
  },
  methods: { 
    RequestdialogSave(a){
      this.showRequestFlag = false;
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("messages.DisclaimerPoints"),
        () => {          
          let postData = {
            SiteID: this.siteID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: a
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MtgappRequestBankStatement", postData)
            .then(res => {
              this.loadFlag = false;
              if (res.data.ReturnStatus.ReturnCode == 200){
                // location.href = res.data.url;
                // window.open(res.data.url);
                window.open(res.data.url, "_blank");
              }else if(res.data.ReturnStatus.ReturnCode == 402){
                 this.$alert(this.$t("Warning"), this.$t("errors.unauthorizedRequest"));
              }else{
                this.$alert(this.$t("Warning"), this.$t("errors.FeatureCreditInsufficientCredits"));
              }
            });
        },
        () => {}
      );
    },
     RequestStatement(){
      this.showRequestFlag = true;
      this.RequestApplicant = null;
    },
    CloseRequestModal(){
      this.showRequestFlag = false;
    },
    isNotRequested(a) {
      if (a.ReceivedFlag) return false;
      return !a.RequestedFlag;
    },
    isRequested(a) {
      if (a.ReceivedFlag) return false;
      return a.RequestedFlag;
    },
    isRecievedS3Key(a) {
      if (a.Responses.length <= 0) return false;
      for (let i = 0; i < a.Responses.length; i++) {
        if (a.Responses[i].S3Key) return true;
      }
      return false;
    },
    isRecieved(a) {
      return a.ReceivedFlag;
    },
    
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          var lan = localStorageSvc.getLanID();
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;   
            for (let i = 0; i < res.data.BankStatementsApplicants.length; i++)
                  this.LstApplicants.push({
                    Label: res.data.BankStatementsApplicants[i].ApplicantName,
                    Value: res.data.BankStatementsApplicants[i].ApplicantID,
                  });                  
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
    back() {
      this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/address");
    },
    
    next() {
      let postData = {        
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };

      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPDoneBankStatement", postData)
        .then(res => {         
          this.loadFlag = false;
          if(res.data.ReturnStatus.ReturnCode == 200){
          
              this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/summary");
            
            
          }else{
            this.$alert(this.$t("Warning"), this.$t("errors.RequestDocumentReqUploads"));
          }
          
          //to summary
        });
    },
    
    
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
       this.frm.LoginID = this.$route.query.loginId;
        this.frm.strTag = this.$route.query.tag;
        this.frm.Institution = this.$route.query.institution;
        this.frm.AccountId = this.$route.query.accountId;        
        if(this.frm.LoginID == null){
          this.loadPage();
        }else{
          this.loadFlag = true;
          dataSvc.getHttp().post('/v1/flinks/SaveFlinksResponse', this.frm).then(res => {
            // this.loadPage();
            this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/bankStatement");          
        });
        }
      
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
  watch: {
  }
};
</script>

<style></style>
